import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, normalizeClass as _normalizeClass, withDirectives as _withDirectives, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "flex flex-col w-full justify-center" }
const _hoisted_2 = {
  key: 0,
  class: "flex items-center gap-2"
}
const _hoisted_3 = { class: "flex items-center" }
const _hoisted_4 = { class: "font-bold text-left text-black text-xl" }
const _hoisted_5 = {
  key: 0,
  class: "text-start text-[#323232] text-md mt-1 font-normal"
}
const _hoisted_6 = {
  key: 1,
  class: "text-red-500 text-xs mt-1 text-left"
}
const _hoisted_7 = {
  key: 1,
  class: "flex w-full md:w-2/4 items-center gap-4"
}
const _hoisted_8 = { class: "flex-1" }
const _hoisted_9 = ["placeholder", "onKeydown"]
const _hoisted_10 = {
  key: 0,
  class: "text-red-500 text-xs mt-1 text-left"
}
const _hoisted_11 = { class: "flex gap-2" }

import { ref, watch, nextTick, onMounted } from 'vue'
import { mdiPencilOutline, mdiCheck, mdiClose } from '@mdi/js'
import { useToast } from 'vue-toastification'

interface Props {
  modelValue: string
  subtitle?: string
  isInitialEditing?: boolean
  placeholder?: string
  errorMessages?: string
  editable?: boolean
}


export default /*#__PURE__*/_defineComponent({
  __name: 'EditableHeader',
  props: {
    modelValue: {},
    subtitle: {},
    isInitialEditing: { type: Boolean, default: false },
    placeholder: { default: 'Nome da política' },
    errorMessages: {},
    editable: { type: Boolean, default: true }
  },
  emits: ["update:modelValue", "save", "cancel", "clear-error"],
  setup(__props: any, { emit }) {

const props = __props;



/* eslint-disable sonarjs/no-duplicate-string */


const toast = useToast()
const isEditing = ref(props.isInitialEditing && props.editable)
const tempName = ref(props.modelValue)
const nameInput = ref<HTMLInputElement | null>(null)

onMounted(() => {
  if (isEditing.value) {
    nextTick(() => nameInput.value?.focus())
  }
})

watch(
  () => props.modelValue,
  (newVal) => {
    if (!isEditing.value) tempName.value = newVal
  }
)

const startEditing = async () => {
  if (!props.editable) return
  tempName.value = props.modelValue
  isEditing.value = true
  await nextTick()
  nameInput.value?.focus()
}

const handleInput = () => {
  emit('update:modelValue', tempName.value)
  emit('clear-error')
}

const saveEdit = () => {
  const trimmedValue = tempName.value.trim()
  if (!trimmedValue) {
    toast.error('Nome inválido.')
    nameInput.value?.focus()
    return
  }
  emit('update:modelValue', trimmedValue)
  emit('save', trimmedValue)
  isEditing.value = false
}

const handleBlur = () => {
  const trimmedValue = tempName.value.trim()
  if (!trimmedValue) {
    isEditing.value = false
    return
  }
  emit('update:modelValue', trimmedValue)
  emit('save', trimmedValue)
  isEditing.value = false
}

const cancelEdit = () => {
  tempName.value = props.modelValue
  isEditing.value = false
  emit('cancel')
}

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (!isEditing.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", null, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("h1", _hoisted_4, _toDisplayString(_ctx.modelValue || 'Sem nome'), 1),
              (_ctx.editable)
                ? (_openBlock(), _createBlock(_component_v_icon, {
                    key: 0,
                    icon: _unref(mdiPencilOutline),
                    class: "cursor-pointer text-primary40 ml-2 hover:opacity-70 transition-opacity",
                    size: "20",
                    "data-testid": "editable-header-edit-button",
                    onClick: startEditing
                  }, null, 8, ["icon"]))
                : _createCommentVNode("", true)
            ]),
            (_ctx.subtitle)
              ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(_ctx.subtitle), 1))
              : _createCommentVNode("", true),
            (_ctx.errorMessages)
              ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.errorMessages), 1))
              : _createCommentVNode("", true)
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            _withDirectives(_createElementVNode("input", {
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((tempName).value = $event)),
              ref_key: "nameInput",
              ref: nameInput,
              type: "text",
              class: _normalizeClass(["border rounded-md px-2 py-1 w-full", _ctx.errorMessages ? 'border-red-500' : 'border-gray-300']),
              placeholder: _ctx.placeholder,
              onKeydown: [
                _withKeys(_withModifiers(saveEdit, ["prevent"]), ["enter"]),
                _withKeys(_withModifiers(cancelEdit, ["prevent"]), ["esc"])
              ],
              onBlur: handleBlur,
              onInput: handleInput
            }, null, 42, _hoisted_9), [
              [_vModelText, tempName.value]
            ]),
            (_ctx.errorMessages)
              ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(_ctx.errorMessages), 1))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_v_icon, {
              icon: _unref(mdiCheck),
              class: "cursor-pointer text-green-600 hover:text-green-700",
              size: "28",
              onMousedown: _withModifiers(saveEdit, ["prevent"])
            }, null, 8, ["icon", "onMousedown"]),
            _createVNode(_component_v_icon, {
              icon: _unref(mdiClose),
              class: "cursor-pointer text-red-600 hover:text-red-700",
              size: "28",
              onMousedown: _withModifiers(cancelEdit, ["prevent"])
            }, null, 8, ["icon", "onMousedown"])
          ])
        ]))
  ]))
}
}

})